import styled, { css } from 'styled-components';

import { base, colors } from '../../../styles';

export const StyledTabNavItem = styled.div`
    cursor: pointer;
    height: 100%;
    margin-bottom: ${base * 2.25}px;
    margin-right: ${base * 4.75}px;
    font-size: 24px;

    ${props => props.active && css`
        color: ${colors.primary};
  `}
`;
